import React, { useEffect } from "react"
import { Portal } from "./portal"
import Illustration from "../../assets/img/joinKuda-scan.inline.svg"


const QrModal = ({ setModalOpen }) => {
    useEffect(() => {
        document.body.classList.add("backdrop-init")
        return () => {
            document.body.classList.remove("backdrop-init")
        }
    }, [])

    return (
        <Portal>
            <div onClick={() => setModalOpen(false)} className="modal modal-backdrop fadeIn animated">
                <div className="modal-content qrCode p-0">
                    <div className="flex justify-center align-center"                    >
                        <Illustration className="w-full" />
                    </div>

                </div>
            </div>
        </Portal>
    )
}

export default QrModal